var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_statistics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "19_Specific-club---matches",
    transform: "translate(-371, -836)",
    fill: "#CFDAE6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(351, 734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_statistics",
    transform: "translate(20, 102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99998633,0.66665625 C7.18398597,0.66665625 7.33332943,0.816 7.33332943,1 L7.33332943,8.21934375 L11.9299767,14.1286562 C12.0406327,14.2713125 12.0179765,14.476 11.878633,14.5906562 C10.5812918,15.6573437 9.55798133,16 7.66664128,16 C3.43933703,16 0,12.560625 0,8.3333125 C0,4.106 3.13999387,0.66665625 6.99998633,0.66665625 Z M6.66664323,1.3426875 C3.32864975,1.53534375 0.666654948,4.59734375 0.666654948,8.33334375 C0.666654948,12.1933437 3.80664882,15.3333437 7.66664128,15.3333437 C9.27063814,15.3333437 10.1486364,15.0813437 11.2012906,14.2773437 L6.73729934,8.538 C6.69129943,8.47934375 6.66664323,8.40734375 6.66664323,8.33334375 Z M15.6666257,8.66665625 C15.8506253,8.66665625 15.9999688,8.816 15.9999688,9 C15.9999688,11.1186563 15.1106267,13.1626563 13.560661,14.608625 C13.4986611,14.6659688 13.4173175,14.6979688 13.3333177,14.6979688 L13.309974,14.6973125 C13.2173179,14.690625 13.1319744,14.646625 13.0739745,14.5739688 L8.74063918,9.2093125 C8.65998309,9.11 8.64329562,8.97265625 8.69863926,8.85665625 C8.7539829,8.74065625 8.87198267,8.66665625 8.99998242,8.66665625 Z M15.3253138,9.33334375 L9.69798106,9.33334375 L13.3619739,13.8693438 C14.5419716,12.6486563 15.243314,11.028 15.3253138,9.33334375 Z M8.33332747,0 C12.5606317,0 16,3.43934375 16,7.66665625 C16,7.85065625 15.8506565,8 15.6666569,8 L8.33332747,8 C8.14932783,8 7.99998438,7.85065625 7.99998438,7.6666875 L7.99998438,0.33334375 C7.99998438,0.14934375 8.14932783,0 8.33332747,0 Z M8.66663932,0.67465625 L8.66663932,7.3333125 L15.3252826,7.3333125 C15.1559704,3.738 12.2619761,0.844 8.66663932,0.67465625 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatistics);
export default __webpack_public_path__ + "static/media/ic_statistics.303c863b5ba1f722f800a2aa239cb023.svg";
export { ForwardRef as ReactComponent };